import { render, staticRenderFns } from "./RmpDetailsGroup.vue?vue&type=template&id=0df38230&scoped=true"
import script from "./RmpDetailsGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpDetailsGroup.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df38230",
  null
  
)

export default component.exports